import fp from "lodash/fp";

import { getStringWithoutHyphens, isDateValid } from "helpers";
import { mapAddressToApi, resetAchFields } from "mappers";

export default function mapBusinessForm(form) {
	if (fp.isEmpty(form)) return;

	const businessAddress = mapAddressToApi(form?.businessAddress);
	const legalAddress = mapAddressToApi(form?.legalAddress);

	const isLegalAddressTheSame =
		form?.legalAddress?.isLegalAddressTheSame === "true" ||
		form?.legalAddress?.isLegalAddressTheSame === true;

	return {
		...form,
		businessAddress,
		legalAddress: isLegalAddressTheSame ? null : legalAddress,
		isLegalAddressTheSame,
		swiped: form.swiped || "0.00",
		keyed: form.keyed || "0.00",
		eCommerce: form.eCommerce || "0.00",
		website: form.website?.toLowerCase(),
		taxId: getStringWithoutHyphens(form.taxId),
		excludeCardTypes: Object.entries(form?.excludeCardTypes || {})
			.filter(([, value]) => value)
			.map(([type]) => type),
		seasonalMonths: form?.seasonalMonths?.map(({ value }) => value),
		businessEstablishedDate: isDateValid(
			"MM/DD/YYYY",
			form?.businessEstablishedDate,
		)
			? form?.businessEstablishedDate
			: null,
		...resetAchFields,
		banks: null,
		billingBanks: null,
		achProcessorHidden: null,
	};
}
